import { mapState } from 'vuex'
import GET_BUSINESS_PROFILE from '@/graphql/GET_BUSINESS_PROFILE.gql'
import MODIFY_BUSINESS_PROFILE from '@/graphql/MODIFY_BUSINESS_PROFILE.gql'


const businessProfileMixin = {
  apollo: {
    businessProfile: {
      skip () {
        return Boolean(!this.services.accountprofile)
      },
      query: GET_BUSINESS_PROFILE,
      variables () {
        return { accountProfileId: this.services.accountprofile }
      },
      update (data) {
        return data.accountProfileGet
      },
      error (error) {
        this.errors = JSON.stringify(error.message)
        return null
      },
      fetchPolicy: 'network-only'
    }
  },
  computed: {
    ...mapState(['services']),
    profileWasUpdated () {
      try {
        if (typeof this.businessProfile !== null) {
          if (this.businessProfile.businessDescription !== null ||
              this.businessProfile.businessName !== null ||
              this.businessProfile.firstName !== null ||
              this.businessProfile.lastName !== null ||
              this.businessProfile.phoneNumber !== null ||
              this.businessProfile.websiteUrl !== null ||
              this.businessProfile.email !== null ||
              this.businessProfile.address.address1 !== null ||
              this.businessProfile.address.address2 !== null ||
              this.businessProfile.address.city !== null ||
              this.businessProfile.address.countryCode !== null ||
              this.businessProfile.address.postalCode !== null ||
              this.businessProfile.address.stateOrProvince !== null) {
            return true
          }
        }
        return false
      } catch (err) {
        return false
      }
    }
  },
  methods: {
    async saveBusinessProfile (profile) {

      var profileData = {
          accountProfileId: profile.accountProfileId,
          businessDescription: profile.business.businessDescription,
          businessName: profile.business.businessName,
          firstName: profile.business.firstName,
          lastName: profile.business.lastName,

          phoneNumber: profile.contact.phoneNumber,
          websiteUrl: profile.contact.webUrl,
          email: profile.contact.email,

          address: {
            address1: profile.address.addressLine1,
            address2: profile.address.addressLine2,
            city: profile.address.city,
            countryCode:  profile.address.countryCode,
            county: profile.address.province,
            postalCode: profile.address.postCode,
            stateOrProvince: profile.address.state,
            hideAddress: profile.address.hideAddress
          }
      }

      try {
        const { data } = await this.$apollo.mutate({
          mutation: MODIFY_BUSINESS_PROFILE,
          variables: {
            accountProfileModification: profileData
          }
        })

        this.$apollo.queries.businessProfile.refresh()
        return true
       } catch (err) {
        return false
       }
    }
  }
}

export default businessProfileMixin
